import { render } from "./Va.vue?vue&type=template&id=1019947e"
import script from "./Va.vue?vue&type=script&lang=js"
export * from "./Va.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__